import {
  ArrowPathIcon,
  CurrencyDollarIcon,
  MegaphoneIcon,
  QueueListIcon,
  UserIcon,
  UsersIcon,
} from '@heroicons/react/24/solid';

const objectIcon = (Icon, displayName) => {
  const DashboardObjectIcon = ({ className = 'h-5 w-5', ...props }) => (
    <Icon aria-hidden="true" className={className} {...props} />
  );

  DashboardObjectIcon.displayName = displayName;
  return DashboardObjectIcon;
};

export const ContactObjectIcon = objectIcon(UserIcon, 'ContactObjectIcon');
export const FormObjectIcon = objectIcon(QueueListIcon, 'FormObjectIcon');
export const PaymentObjectIcon = objectIcon(CurrencyDollarIcon, 'PaymentObjectIcon');
export const SubscriptionObjectIcon = objectIcon(ArrowPathIcon, 'SubscriptionObjectIcon');
export const BroadcastObjectIcon = objectIcon(MegaphoneIcon, 'BroadcastObjectIcon');
export const SegmentObjectIcon = objectIcon(UsersIcon, 'SegmentObjectIcon');
